import { Select } from '@e3dc-react/shell/Elements/Select'
import React from 'react'
import { AvailableSorting } from '../../models/shop-product-category.model'

interface ShopProductCategorySortProps {
  selectedSorting: string
  availableSortings: AvailableSorting[]
  onChange: (value: string) => void
}

/*
 * Renders a dropdown for selecting sorting options in a shop product category.
 * Sorts the available options by priority and formats them for display.
 */
const ShopProductCategorySort: React.FC<ShopProductCategorySortProps> = ({ availableSortings, selectedSorting, onChange }) => {
  const formattedSorting = availableSortings
    .sort((a, b) => a.priority - b.priority)
    .map(sort => ({
      value: sort.key,
      label: sort.translated.label,
    }))

  return <Select fullWidth={false} options={formattedSorting} value={selectedSorting} onChange={onChange} />
}

export default ShopProductCategorySort
